import React from 'react';
import PropTypes from 'prop-types';
import {observer} from 'mobx-react';
import RecentQuery from 'ferries/Home/components/FerrySearchMask/PopularPortOverlay/RecentQuery';

const LastSearches = ({queries, onClickQuery, translations}) => (
  <div>
    <h4 className='mb-4'>{translations.recentSearches}</h4>
    {queries.map((query, i) =>
      <RecentQuery
        key={i}
        query={query}
        wrapperClass="mb-3"
        onClickQuery={onClickQuery}
        translations={translations}
      />
    )}
  </div>
);

LastSearches.propTypes = {
  queries: PropTypes.object.isRequired,
  onClickQuery: PropTypes.func.isRequired,
  translations: PropTypes.shape({
    recentSearches: PropTypes.string.isRequired,
    trips: PropTypes.string.isRequired
  })
};

export default observer(LastSearches);
